var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    {
      attrs: {
        title:
          _vm.id === null
            ? "Cadastrar Pessoa Jurídica"
            : "Editar Pessoa Jurídica"
      }
    },
    [
      _c(
        "vs-tabs",
        {
          attrs: { color: _vm.colorx },
          model: {
            value: _vm.tabIndex,
            callback: function($$v) {
              _vm.tabIndex = $$v
            },
            expression: "tabIndex"
          }
        },
        [
          _c(
            "vs-tab",
            { attrs: { label: "Dados Básicos" } },
            [
              _c("LegalEntityForm", {
                attrs: { legalEntityId: _vm.id, services: _vm.services }
              })
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Endereço", disabled: _vm.isTabEnabled } },
            [
              _c("Address", {
                attrs: {
                  services: _vm.services,
                  addressTypeList: _vm.addressTypeList
                }
              })
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Telefone", disabled: _vm.isTabEnabled } },
            [_c("Phone", { attrs: { services: _vm.services } })],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Email", disabled: _vm.isTabEnabled } },
            [
              _c("Email", {
                attrs: {
                  services: _vm.services,
                  emailTypeList: _vm.emailTypeList
                }
              })
            ],
            1
          ),
          _c(
            "vs-tab",
            {
              attrs: {
                label: "Unidade Organizacional",
                disabled: _vm.isTabEnabled
              }
            },
            [
              _c("OrganizationalUnitList", {
                attrs: { services: _vm.services, legalEntityId: _vm.id }
              })
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Formulários", disabled: _vm.isTabEnabled } },
            [
              _c(
                "vx-card",
                [
                  _c(
                    "vs-tabs",
                    { attrs: { color: _vm.colorx } },
                    [
                      _c(
                        "vs-tab",
                        { attrs: { label: "LGPD" } },
                        [
                          _c("PrivacyRequest", {
                            attrs: { legalEntityId: _vm.id }
                          })
                        ],
                        1
                      ),
                      _c(
                        "vs-tab",
                        { attrs: { label: "Incidente" } },
                        [_c("incident", { attrs: { legalEntityId: _vm.id } })],
                        1
                      ),
                      _c(
                        "vs-tab",
                        { attrs: { label: "Due Diligence" } },
                        [
                          _c("due-diligence", {
                            attrs: { legalEntityId: _vm.id }
                          })
                        ],
                        1
                      ),
                      _c(
                        "vs-tab",
                        { attrs: { label: "Intimidação Sistemática" } },
                        [
                          _c("systematic-intimidation", {
                            attrs: { legalEntityId: _vm.id }
                          })
                        ],
                        1
                      ),
                      _c(
                        "vs-tab",
                        { attrs: { label: "Formulário de Relato" } },
                        [
                          _c("ReportingChannel", {
                            attrs: { legalEntityId: _vm.id }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }